import ActivityManagerContainer from "../../container/admin/activity-manager";

const ActivityManager = () => {
    return <ActivityManagerContainer />;
};

export default ActivityManager;